import {history} from '../history';
import { store } from '../stores/mainStore';



//onLaunch, onResume = user took an action from outside the app
//onMessage = show user the notification in app.

export function notificationManager(payload, mode){

	var MatchId, Type;

	try {
		// payload = JSON.parse(payload);
		MatchId = payload.MatchId;
		Type = payload.Type;
	} catch (error) {
		var regex = /MatchId:.*?(\d*?),.*Type:.*?(\w*),/gm;

		var parsed = regex.exec(payload);

		MatchId = parsed[1];
		Type = parsed[2];
	}

	let validMatch = (Type === 'your_turn' || Type === 'challenged') && MatchId && MatchId !== null && MatchId !== '' && MatchId > 0;

	//console.log(payload);

	const typeToPath = {
		challenged: 'play',
		your_turn: 'play',
		nudge: 'play',
		match_complete: 'view'
	}

	let passOn = Type === 'your_turn' || Type === 'match_complete' || Type === 'nudge';

	if(mode === 'onMessage'){
		if(passOn) {
			store.notifications.push(payload);
			store.awaitingNotifications = true;
			store.getLobbyData(true);
		}
	} else {
		if(Type === 'resignation' || Type === 'auto_resign'){
			store.getLobbyData().then(() => {
  				history.push('/');
			})
		} else {
			if(validMatch){
				history.push(`/game/${MatchId}/${typeToPath[Type]}`)
			} else {
				store.getLobbyData().then(() => {
					history.push('/');
				})
			}
		}
	}
}


//should have called it set fcmId.
export function registerFCM(id){
	console.log('registerFCM called, id is set');

	if(store.settings.notifications !== 'off'){
		store.fcmId = id;
	}
}
export function clearBadgeCounter(){
	console.log('clearBadgeCounter called');
	if(window.WrapperApp)
		window.WrapperApp.postMessage("clear-badgecounter");
}
export class FCM {
	commands = [];
	processing = false;
	constructor(commands){
		this.commands = commands || [];
		this.process();
	}
	push(){
		this.commands.push(...arguments);
		this.process();
	}
	process(){
		if(this.commands.length){
			this.processing = true;
			var c = this.commands.shift();
			switch (c[0]) {
				case 'register':
					console.log('register for push', c);
					registerFCM(c[1]);
					break;
				case 'notify':
					notificationManager(JSON.parse(c[1]), c[2])
					break;
				default:
					console.warn('command not found', c);
					break;
			}
		}
		if(this.commands.length){
			this.process();
		} else {
			this.processing = false;
		}
	}
}
